import { ActionType } from '@/types/enums'

/** Short name of a trigger, as shown on automation cards and lists. */
export function getTriggerLabel(trigger: string): string {
  switch (trigger) {
    case ActionType.CREATE: return 'On Create'
    case ActionType.UPDATE: return 'On Update'
    case ActionType.DELETE: return 'On Delete'
    case ActionType.CALL_ENDED: return 'Call ended'
    case ActionType.CALL_DISPOSITION_SET: return 'Call disposition'
    case ActionType.TAG_ADDED: return 'Tag added'
    case ActionType.TAG_REMOVED: return 'Tag removed'
    case ActionType.NOTE_ADDED: return 'Note added'
    case ActionType.BUTTON_CLICKED: return 'Button clicked'
    default: return trigger
  }
}
